<template>
    <b-card class="mb-0 five9-graphs-cards expand-card" :class="expandGraphs ? 'expand-graph' : '' " style="min-height:200px" v-b-visible="mountedAction">
        <template v-slot:header>
            <span class="h6"><i class="fa-duotone fa-chart-line-down mr-1"></i>  Declines</span>
        </template>
        <b-row>
            <b-col sm="4">
                <vc-date-picker v-model="dateRange" :popover="datePickerProps" is-range class="" :model-config="modelConfig">
                    <template v-slot="{ inputValue, inputEvents }">
                        <b-row class="no-gutters">
                            <b-col>
                                <div class="text-center form-control" v-on="loading ? null : inputEvents.start" :disabled="loading">
                                    {{ dateRange.start | date }}{{ dateRange.start ? '': 'mm-dd-yyyy' }} - {{ dateRange.end | date }}{{ dateRange.end ? '': 'mm-dd-yyyy' }}
                                </div>
                            </b-col>
                        </b-row>
                    </template>
                </vc-date-picker>
            </b-col>
            <b-col cols="2">
                <b-button size="sm" block @click="setThisMonth" class="font-weight-bold cancel-button" variant="danger">
                    <i class="fa-regular fa-calendar-check mr-1"></i> This Month
                </b-button>
            </b-col>
            <b-col cols="2">
                <b-button size="sm" block @click="setLastMonth" class="font-weight-bold cancel-button" variant="danger">
                    <i class="fa-regular fa-calendar mr-1"></i>Last Month
                </b-button>
            </b-col>
        </b-row>
        <b-table
                show-empty
                class="orders-dropdown-table"
                small
                :fields="fields"
                :items="values"
                :busy.sync="loading"
        >
            <template v-slot:table-busy>
                <LoadingSpinner :busy="loading" heavy-data-load/>
            </template>
            <template v-slot:cell(saves_percent)="data">
                {{ data.value | toFixed2}}%
            </template>
            <template v-slot:cell(total_av)="data">
                ${{data.value | toFixed2}}
            </template>
            <template v-slot:cell(retained_value)="data">
                ${{data.value | toFixed2}}
            </template>
            <template v-slot:cell(retained_percent)="data">
                {{ data.value | toFixed2}}%
            </template>
            <template v-slot:cell(customer_paid)="data">
                ${{data.value | toFixed2}}
            </template>
            <template v-slot:cell(customer_paid_rate)="data">
                {{ data.value | toFixed2}}%
            </template>
            <template v-slot:cell(profit_per_dollar_negotiated)="data">
                ${{data.value | toFixed2}}
            </template>

        </b-table>

        <b-row>
            <b-form-radio size="sm"
                          class="mr-4 ml-3"
                          v-model.number="bullion"
                          value="null">
                <span class="label">All</span>
            </b-form-radio>
            <b-form-radio size="sm"
                          class="mr-4"
                          v-model.number="bullion"
                          value="1">
                <span class="label">Bullion</span>
            </b-form-radio>
            <b-form-radio size="sm"
                          class="mr-4"
                          v-model.number="bullion"
                          value="0">
                <span class="label">Non-Bullion</span>
            </b-form-radio>
        </b-row>
    </b-card>
</template>

<script>
    import _ from 'lodash';
    import LoadingSpinner from '../../../components/LoadingSpinner';
    import moment from 'moment';
    import DateRangePicker from 'vue2-daterange-picker';
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
    export default {
        components: {LoadingSpinner, DateRangePicker,},
        name: 'Declines',
        expandGraphs: false,
        props: {

        },
        data() {
            return {
                expandGraphs: false,
                datePickerProps: {
                    placement: 'bottom',
                },
                modelConfig: {
                    start: {
                        timeAdjust: '00:00:00',
                    },
                    end: {
                        timeAdjust: '23:59:59',
                    },
                },
                bullion: null,
                dateRange: {
                    start: null,
                    end: null
                },
                fields: [
                    {label: 'Agent', key: 'agent'},
                    {label: 'Declined', key: 'declined'},
                    {label: 'Saved', key: 'saved'},
                    {label: 'Saved %', key: 'saves_percent'},
                    {label: 'Total AV', key: 'total_av'},
                    {label: 'Retained %', key: 'retained_percent'},
                    {label: 'Retained Value', key: 'retained_value'},
                    {label: 'Customer Paid', key: 'customer_paid'},
                    {label: 'Customer Paid Rate', key: 'customer_paid_rate'},
                    {label: 'Profit', key: 'profit_per_dollar_negotiated'},
                ],
                loading: false,
                values: null,
            };
        },
        beforeDestroy(){
            clearInterval(this.interaval);
        },
        created() {
            this.setThisMonth();
        },
        methods: {
            formatDate(date_str){
                if (date_str) {
                    return moment(String(date_str)).format('MM/DD/YYYY');
                }
                return date_str;
            },
            setThisMonth() {
                var date = new Date();
                this.dateRange.start = new Date(date.getFullYear(), date.getMonth(), 1);
                this.dateRange.end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                this.getData();
            },
            setLastMonth() {
                var date = new Date();
                this.dateRange.start = new Date(date.getFullYear(), date.getMonth() - 1, 1);
                this.dateRange.end = new Date(date.getFullYear(), date.getMonth(), 0);
                this.getData();
            },
            deBounce: _.debounce(function() {
                if(this.filter.length > 4) {
                    this.updateSearch();
                } else {

                }
            }, 1500),
            updateDate(){
                this.getData();
            },
            getData() {
                let data = {
                    'start': this.formatDate(this.dateRange.start),
                    'end': this.formatDate(this.dateRange.end),
                    'bullion': this.bullion
                };
                this.values = null;
                this.loading = true;
                this.$http.post('/dashboards/Declines/' , data).then((data) => {
                    this.values = [];
                    _.forEach(data.data.data.values, (value) => {
                        this.values.push(value);
                    });
                    this.loading = false;
                });
            },
            mountedAction() {

            },
            expandGraph() {
                this.expandGraphs = this.expandGraphs;
            },
        },
        updateSearch(event) {
            if (event) {
                event.preventDefault();
            }
            this.getData();
        },
        watch: {
            dateRange: function(val){
                this.updateDate();
            },
            bullion: function(val) {
                this.getData();
            }
        }
    };

</script>


<style scoped>
    .merge-card {
        flex: 1;
        margin:0 1.5%;
    }

    .data {
        flex: 1;
        border-bottom: 1px solid #f4f4f4;
        margin-bottom: 2px
    }
    .data__title {
        font-weight: 400;
    }
    .data__num {
        float: right;
    }

    .display_on_top {
        z-index: 1000;
    }

    .card {
        flex: 1;
        /*margin: 0 8px;*/
        transition: .3s ease-in-out;
    }

    .card.expand-graph {
        flex: 5 !important;
    }
    .font-uppercase {
        text-transform: uppercase;
    }

</style>